import { layoutParty } from "apps/Partyv2/Party";
// import funcs from "tools/functions";

// const terminal = funcs.getCookie();

function layout(props = {}) {
  const { statementId, name } = props;

  const ctxView = {
    model: "sale_pos.expenses_daily",
    form_action: ["edit", "add", "delete"],
    table_action: ["add", "open"],

    domain: [["statement.id", "=", statementId]],
    activeSearch: true,
    fields: {
      statement: {
        type: "many2one",
        model: "account.statement",
        required: true,
        readOnly: true,
        default: () => {
          return {
            id: statementId,
            name: name,
          };
        },
      },
      invoice_number: {
        type: "char",
        required: true,
      },
      description: {
        type: "char",
        required: true,
      },
      amount: {
        type: "numeric",
        digits: [16, 2],
        required: true,
      },
      party: {
        type: "many2one",
        model: "party.party",
        recSearch: () => [],
        searchable: true,
        layout: layoutParty,
      },
      create_uid: {
        type: "many2one",
        model: "ir.user",
        readOnly: true,
        attrs: ["name"],
      },
      reference: {
        type: "char",
      },
    },

    list: [
      { name: "invoice_number" },
      { name: "reference", width: "20%" },
      { name: "description" },
      { name: "amount", width: "15%" },
    ],

    form: [
      { name: "statement" },
      { name: "party" },
      { name: "invoice_number" },
      { name: "description" },
      { name: "reference" },
      { name: "amount" },
      { name: "create_uid" },
    ],
  };

  return ctxView;
}

export { layout };
